import type { ReactNode } from "react";
import {
  I18nProvider as FoundationI18nProvider,
  useT as useFoundationT,
  type Locale,
} from "@csa/web-foundation";
import { dictionaries, type MessageKey } from "./dictionaries";

// The customer app's i18n — Turkish-FIRST (initial "tr"), on the shared foundation
// machinery. Surfaces import `useT`/`I18nProvider` from `../i18n`.
export function I18nProvider({
  children,
  initial = "tr",
}: {
  children: ReactNode;
  initial?: Locale;
}) {
  return (
    <FoundationI18nProvider dictionaries={dictionaries} initial={initial}>
      {children}
    </FoundationI18nProvider>
  );
}

export function useT() {
  return useFoundationT<MessageKey>();
}

export type { Locale };
